import { lazy, type FC, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';
import { type EndAuctionProps } from './EndAuctionModal';

const EndAuctionModal = lazy(
    () => import(/* webpackChunkName: "EndAuctionModal" */ './EndAuctionModal')
);

export const EndAuctionModalLazy: FC<EndAuctionProps> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback="">
            <EndAuctionModal {...props} />
        </Suspense>
    ) : null;
};
